/**
 * Find the cartesian product of two arrays. For example:
 * cartesian([1, 2], ["a", "b"]) should return [[1, "a"], [1, "b"], [2, "a"], [2, "b"]].
 */
export default function cartesian<T, U>(a: T[], b: U[]): [T, U][] {
  const result: [T, U][] = [];
  a.forEach(x => {
    b.forEach(y => {
      result.push([x, y]);
    });
  });
  return result;
}
